import React from 'react';

function Differentiators() {
  return (
    <section id="why-choose-us-section" className="section-padding">
      <div className="container">
        <h2>Cognitive Excellence: Why Partner with Savage Technologies for Agents</h2>
        <div className="differentiators-grid">
          
          <div className="differentiator-item">
            <div className="item-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10" />
                <path d="M12 2v20" />
                <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
              </svg>
            </div>
            <h3>Autonomous Capabilities</h3>
            <p>Our agents do not just recommend actions; they autonomously execute complex business plans, manage DB entries, and connect endpoints safely.</p>
          </div>

          <div className="differentiator-item">
            <div className="item-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21.5 2v6h-6M21.34 15.57a10 10 0 1 1-.57-8.38l5.67-5.67" />
              </svg>
            </div>
            <h3>Continuous Optimization</h3>
            <p>Through active self-learning feedback loops, our agents analyze their own execution traces, learning with every single trajectory.</p>
          </div>

          <div className="differentiator-item">
            <div className="item-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <rect width="18" height="11" x="3" y="11" rx="2" ry="2" />
                <path d="M7 11V7a5 5 0 0 1 10 0v4" />
              </svg>
            </div>
            <h3>Enterprise Guardrails</h3>
            <p>We build safety gates, strict IAM permissions, and prompt injection defenses to protect your intellectual assets at all times.</p>
          </div>

          <div className="differentiator-item">
            <div className="item-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z" />
                <path d="m10 8 6 4-6 4V8z" />
              </svg>
            </div>
            <h3>Dual-Cloud Architecture</h3>
            <p>We leverage GCP's bleeding-edge intelligence and Oracle OCI's robust databases, choosing the absolute best platform for every agent task.</p>
          </div>

          <div className="differentiator-item">
            <div className="item-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                <polyline points="22 4 12 14.01 9 11.01" />
              </svg>
            </div>
            <h3>Proven Trajectory ROI</h3>
            <p>Our solutions deliver clear, quantifiable reductions in API costs, operational speeds, and task execution error rates.</p>
          </div>

        </div>

        <div className="methodology-section">
          <h3>Our Proprietary Agentic Enablement Framework</h3>
          <p>We implement a strict, collaborative integration process to transition your business workflows into highly secure autonomous multi-agent systems.</p>
          <div className="methodology-graphic">
            {/* Custom High-Tech SVG Methodology Flowchart */}
            <svg viewBox="0 0 600 120" style={{ width: '100%', height: 'auto' }}>
              <defs>
                <linearGradient id="flowGrad" x1="0%" y1="0%" x2="100%" y2="0%">
                  <stop offset="0%" stopColor="var(--primary)" />
                  <stop offset="100%" stopColor="var(--secondary)" />
                </linearGradient>
              </defs>
              <rect x="10" y="20" width="110" height="60" rx="10" fill="none" stroke="var(--primary)" strokeWidth="1.5" />
              <text x="65" y="55" fill="#fff" fontSize="10" fontWeight="600" textAnchor="middle">1. COGNITIVE SCOPE</text>
              
              <line x1="120" y1="50" x2="160" y2="50" stroke="url(#flowGrad)" strokeWidth="2" strokeDasharray="3,3" />
              
              <rect x="160" y="20" width="110" height="60" rx="10" fill="none" stroke="var(--primary)" strokeWidth="1.5" />
              <text x="215" y="55" fill="#fff" fontSize="10" fontWeight="600" textAnchor="middle">2. AGENT DESIGN</text>
              
              <line x1="270" y1="50" x2="310" y2="50" stroke="url(#flowGrad)" strokeWidth="2" />
              
              <rect x="310" y="20" width="110" height="60" rx="10" fill="none" stroke="var(--primary)" strokeWidth="1.5" />
              <text x="365" y="55" fill="#fff" fontSize="10" fontWeight="600" textAnchor="middle">3. TOOL INTEGRATION</text>
              
              <line x1="420" y1="50" x2="460" y2="50" stroke="url(#flowGrad)" strokeWidth="2" strokeDasharray="3,3" />
              
              <rect x="460" y="20" width="110" height="60" rx="10" fill="none" stroke="var(--secondary)" strokeWidth="1.5" />
              <text x="515" y="55" fill="#fff" fontSize="10" fontWeight="600" textAnchor="middle">4. TELEMETRY AUDIT</text>
            </svg>
          </div>
        </div>

        <div className="client-success-section">
          <h3>Agent Implementations. Quantifiable Impact.</h3>
          <div className="testimonials-grid">
            
            <div className="testimonial-card">
              <p>
                "Savage Technologies deployed a multi-agent customer billing reconciliation network. Operating autonomously on GCP, it coordinates with our OCI billing ledgers, reducing auditing latency by 85% and cutting manual reconciliation discrepancies to zero."
              </p>
              <div className="client-info">
                {/* Tech logo representation */}
                <svg viewBox="0 0 24 24" style={{ height: '24px', color: 'var(--primary)' }} fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" />
                </svg>
                <span className="client-name">Leading FinTech Operations Platform</span>
              </div>
            </div>

            <div className="testimonial-card">
              <p>
                "We automated our complex warehouse supply replenishment using Savage cognitive agents. The agents run planner-execution loops in real-time, autonomously triggering restocking APIs based on Autonomous DB stock levels, increasing order fulfillment rates by 22%."
              </p>
              <div className="client-info">
                {/* Logistics logo representation */}
                <svg viewBox="0 0 24 24" style={{ height: '24px', color: 'var(--secondary)' }} fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
                  <path d="M8 21h8" />
                  <path d="M12 17v4" />
                </svg>
                <span className="client-name">Enterprise E-Commerce & Retail Syndicate</span>
              </div>
            </div>

          </div>
        </div>

      </div>
    </section>
  );
}

export default Differentiators;
